import { Type } from '@angular/core';
import {
  OrderHistoryComponent,
  ProductInformationComponent,
  SrmComponent,
} from '../components';

export type ServiceComponent = Type<
  SrmComponent |
  OrderHistoryComponent |
  ProductInformationComponent
>;

export const DIGITAL_SERVICE_COMPONENT_MAP: Record<string, ServiceComponent> = {
  'service-request-management': SrmComponent,
  'order-history': OrderHistoryComponent,
  'product-information': ProductInformationComponent,
};
